import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentParticipantMusic = new CRUD('tournament-participant-musics', 'superior-judge')

export default Object.assign(
    tournamentParticipantMusic,
    {
        reducers: {
            ...tournamentParticipantMusic.reducers
        },

        generate: (id) => {
            return async (dispatch) => {
                dispatch(tournamentParticipantMusic.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participant-musics/${id}/generate`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        approve: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participant-musics/${id}/approve`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        decline: (id, message=null) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participant-musics/${id}/decline`, {
                        message
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        delete: (id) => {
            return async (dispatch) => {
                try {
                    return axios.delete(`/superior-judge/tournament-participant-musics/${id}/delete`)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
